import React from 'react';
export var EligibilityContainer = function EligibilityContainer(_ref) {
  var ariaLabel = _ref['aria-label'],
    children = _ref.children,
    color = _ref.color;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": ariaLabel,
    style: {
      color: color,
      display: 'inline-block',
      width: '26px'
    }
  }, children);
};
export var EligibilityIcon = function EligibilityIcon(_ref2) {
  var pass = _ref2.pass;
  return pass ? /*#__PURE__*/React.createElement(EligibilityContainer, {
    "aria-label": "Pass Eligibility",
    color: "#148750"
  }, "\u2713") : /*#__PURE__*/React.createElement(EligibilityContainer, {
    "aria-label": "Ineligible",
    color: "#be0e31"
  }, "\uD800\uDD02");
};
export default EligibilityIcon;